import React from 'react'

import Select from 'Components/Select'
import Input from 'Components/Input'
import Constants from 'EurestoFonction/Constants'
import Grid from '@material-ui/core/Grid'
import Title from 'Components/Title'

export default React.memo(props => <Title inline={props.inline} title={props.title}>
  <Grid container style={{ margin: 0, padding: 0 }} spacing={0} justify={'center'}
        alignItems={'center'}>
    <Grid item xs={6} style={{ margin: 0, padding: 5 }}>
      <Select style={props.style} options={props.options} onChange={props.onChange}
              disabled={props.disabled || false}
              value={props.infoTiers === true && props.data !== undefined ? props.data.id : props.data}/>
    </Grid>
    <Grid item xs={6} style={{ margin: 0, padding: 5 }}>
      <Input
        onChange={props.onChangeComboSimpleSaisieLibre}
        disabled={props.disabled || false}
        name={'valeur_text'}
        value={props.data !== undefined && props.data.valeur_text !== undefined ? props.data.valeur_text : ""}
      />
    </Grid>
  </Grid>
</Title>)



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataComponent/Components/ComboSimpleSaisieLibre.js